module.exports = "<img ng-src=\"{{$ctrl.logoUrl}}\" class=\"volusion-logo\" ng-class=\"{'volusion-logo--clickable': $ctrl.clickable}\" ng-click=\"$ctrl.onClick()\" alt=\"Volusion Logo\"> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/logo/logo.html
// module id = 1379
// module chunks = 28